import { useAtomValue } from "jotai";
import React from "react";
import { closeContentCards, contentCardsAtom, contentCardsOpenAtom, getBraze } from "utils/braze";

export function ContentCards() {
  const container = React.useRef<HTMLDivElement>(null);
  const contentCards = useAtomValue(contentCardsAtom);
  const isOpen = useAtomValue(contentCardsOpenAtom);
  React.useEffect(() => {
    if (!isOpen) return;
    void getBraze().then((braze) => {
      if (!braze) return;
      braze.showContentCards(container.current);
      document.getElementsByClassName("ab-close-button")[0].addEventListener("click", closeContentCards);
    });
  }, [isOpen, contentCards]);

  if (!isOpen) return null;
  return (
    <div
      ref={container}
      className="size-full overflow-hidden overflow-y-auto bg-light-gray [&_.ab-close-button]:hidden! md:[&_.ab-close-button]:block! [&_.ab-feed_.ab-card_.ab-close-button]:hidden! [&_.ab-feed_.ab-card_.ab-url-area]:text-brand! [&_.ab-feed.ab-effect-slide.ab-show]:transition-none! [&>.ab-feed,&>.ab-feed_.ab-card_.ab-title]:font-sans!"
    />
  );
}
